const Loading = () => (
  <div className="tw-absolute tw-inset-0 tw-flex tw-justify-center tw-items-center tw-bg-white tw-bg-opacity-50 tw-z-50">
    <i className="tw-text-36px tw-text-gray-50 fa fa-spinner fa-spin" />
  </div>
);

export default Loading;
